import React from 'react';
import PropTypes, { resetWarningCache } from 'prop-types';
import MasterFullpageResult from './MasterFullpageResult';
import { resultTypes } from '../../constants/constants';
import MasterStickyHeadersResult from '../RetirementFlow/MasterStickyHeadersResult';

const ResultByType = ({ type, children, ...props }) => {
  switch (type) {
    case resultTypes.FULLSCREEN:
      return <MasterFullpageResult {...props}>{children}</MasterFullpageResult>;
    case resultTypes.STICKY:
      return <MasterStickyHeadersResult {...props}>{children}</MasterStickyHeadersResult>;
    default:
      return `Result of type (${type}) not found.`;
  }
};

ResultByType.propTypes = {
  type: PropTypes.string,
};

export default ResultByType;
